import React, { useState } from 'react';
import TOUScheduleEditor from './gridmarket/TOUScheduleEditor';
import TariffList from './gridmarket/TariffList';
import TariffDetail from './gridmarket/TariffDetail';
import PublicHolidaysTable from './gridmarket/PublicHolidaysTable';

const API = process.env.REACT_APP_API_URL || `http://${window.location.hostname}:5001`;

const COLORS = {
  bg: '#0f172a',
  panel: '#1e293b',
  border: '#334155',
  text: '#e2e8f0',
  textDim: '#94a3b8',
  accent: '#4ecca3',
};

const TABS = [
  { id: 'tariffs', label: 'Tariffs' },
  { id: 'tou', label: 'TOU Schedules' },
  { id: 'holidays', label: 'Public Holidays' },
];

const GridMarketView = () => {
  const [activeTab, setActiveTab] = useState('tariffs');
  const [selectedTariffId, setSelectedTariffId] = useState(null);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      height: '100vh',
      background: COLORS.bg,
      color: COLORS.text,
      fontFamily: "'Work Sans', sans-serif",
    }}>
      {/* Header */}
      <div style={{
        padding: '20px 24px',
        borderBottom: `1px solid ${COLORS.border}`,
        background: COLORS.panel,
      }}>
        <h1 style={{
          margin: 0,
          fontSize: '22px',
          fontWeight: 600,
          fontFamily: "'Space Grotesk', sans-serif",
          color: COLORS.text,
        }}>
          Grid/Market
        </h1>
        <div style={{
          marginTop: '4px',
          fontSize: '13px',
          color: COLORS.textDim,
        }}>
          Reference data for utility tariffs, time-of-use schedules and public holidays
        </div>
      </div>

      {/* Tabs */}
      <div style={{
        display: 'flex',
        gap: '2px',
        padding: '0 24px',
        background: COLORS.panel,
        borderBottom: `1px solid ${COLORS.border}`,
      }}>
        {TABS.map((tab) => {
          const isActive = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              style={{
                padding: '12px 20px',
                background: 'transparent',
                border: 'none',
                borderBottom: isActive ? `2px solid ${COLORS.accent}` : '2px solid transparent',
                color: isActive ? COLORS.text : COLORS.textDim,
                fontSize: '14px',
                fontWeight: isActive ? 600 : 400,
                cursor: 'pointer',
                fontFamily: 'inherit',
              }}
            >
              {tab.label}
            </button>
          );
        })}
      </div>

      {/* Tab content */}
      <div style={{ flex: 1, overflow: 'auto', padding: '24px' }}>
        {activeTab === 'tariffs' && (
          <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
            <TariffList selectedTariffId={selectedTariffId} onSelect={setSelectedTariffId} />
            <TariffDetail tariffId={selectedTariffId} />
          </div>
        )}
        {activeTab === 'tou' && <TOUScheduleEditor />}
        {activeTab === 'holidays' && <PublicHolidaysTable />}
      </div>
    </div>
  );
};

export default GridMarketView;
